<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <ul class="tabs" style="margin: 0; top: 0">
      <li :class="changeType == 1 ? 'shadow' : ''">
        <a
          @click="changeTable('1')"
          :class="changeType == 1 ? 'active' : ''"
          href="javascript:;"
          >{{ $t("product.库存商品管理") }}</a
        >
      </li>
      <li
        v-if="!$root.$children[0].userInfo.rootUrl"
        :class="changeType == 3 ? 'shadow' : ''"
      >
        <a
          @click="changeTable('3')"
          :class="changeType == 3 ? 'active' : ''"
          href="javascript:;"
          >{{ $t("product.电子券类型商品管理") }}</a
        >
      </li>
      <li
        v-if="!$root.$children[0].userInfo.rootUrl"
        :class="changeType == 99 ? 'shadow' : ''"
      >
        <a
          @click="changeTable('99')"
          :class="changeType == 99 ? 'active' : ''"
          href="javascript:;"
          >{{ $t("product.工艺管理") }}</a
        >
      </li>
      <li
        v-if="!$root.$children[0].userInfo.rootUrl"
        :class="changeType == 5 ? 'shadow' : ''"
      >
        <a
          @click="changeTable('5')"
          :class="changeType == 5 ? 'active' : ''"
          href="javascript:;"
          >{{ $t("product.原料商品管理") }}</a
        >
      </li>
    </ul>
    <div
      class="body-bg card bd-gray-400"
      v-if="changeType == 1 || changeType == 3"
    >
      <!-- new list -->
      <div v-if="1" class="list-wrap mg-b-15">
        <!-- header -->
        <div class="list-heard d-flex mg-b-5">
          <div class="pd-l-5 d-flex justify-content-center">
            <label class="ckbox">
              <input
                type="checkbox"
                :checked="isAll"
                @change="changeAllCheck($event)"
              />
              <span></span>
            </label>
          </div>
          <div class="d-flex pd-x-5 flex-1">
            <div class="c-7 tx-white">{{ $t("product.商品信息") }}</div>
            <div class="c-4 tx-white">{{ $t("product.销售信息") }}</div>
            <div class="c-5 tx-white">{{ $t("product.库存信息") }}</div>
            <div class="c-2 tx-white">{{ $t("product.状态") }}</div>
            <div class="c-3 tx-white">{{ $t("product.货盘审核拒绝原因") }} <br> {{ $t("product.备注") }}</div>
            <div class="c-3 tx-white">{{ $t("product.操作") }}</div>
          </div>
        </div>
        <!-- header end -->
        <!-- list -->
        <div
          v-for="(item, index) in items"
          :key="item.id"
          class="list-body d-flex mg-b-10"
        >
          <div class="pd-l-5 d-flex justify-content-center">
            <label class="ckbox mg-b-0">
              <input
                type="checkbox"
                :value="item.sku"
                v-model="checkArr"
              /><span></span>
            </label>
          </div>
          <div class="flex-1 pd-x-5 product-table card bd-gray-400 pd-5">
            <div class="d-flex align-items-center">
              <div class="c-7">
                <div class="d-flex overflow-hidden">
                  <a
                    class="mg-r-10 img-wrap d-block"
                    href="javascript:;"
                    :class="{ isIll: $isIll(item.propertyImage) }"
                    v-lazy:background-image="item.propertyImage"
                    @click="preview(item.propertyImage, item.name)"
                  ></a>
                  <div class="pro-info">
                    <div class="tx-ellipsis2">
                      {{ $t("product.商品标题") }}：
                      <span class="tx-white">{{ item.name }}</span>
                    </div>
                    <div class="">
                      <div v-if="item.sku">
                        SKU：
                        <span class="tx-white">
                          {{ item.sku }}
                          <a
                            href="javascript:;"
                            class="tx-info to-clipboard"
                            :data-clipboard-text="item.sku"
                          >
                            <i class="icon ion-clipboard"></i>
                          </a>
                          <el-tooltip placement="right">
                            <div slot="content">
                              <div>
                                <div class="d-flex align-items-center justify-content-between">
                                  <span>{{ $t("rm.操作日志：")}}</span>
                                  <el-button type="text" size="mini" @click="checkHistoryLog(item)">{{$t("rm.查看更多")}}</el-button>
                                </div>
                                <div v-for="(log, index) of item.operateLog" :key="index">{{log}}</div>
                              </div>
                            </div>
                            <i v-if="item.operateLog.length" class="mg-l-5 tx-white el-icon-info" @click="checkHistoryLog(item)"></i>
                          </el-tooltip>
                        </span>
                      </div>
                      <div v-if="item.spu">
                        SPU：
                        <span class="tx-white">
                          {{ item.spu }}
                          <a
                            href="javascript:;"
                            class="tx-info to-clipboard"
                            :data-clipboard-text="item.spu"
                          >
                            <i class="icon ion-clipboard"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                    <div v-if="item.propertyValue" class="tx-ellipsis1">
                      {{ $t("product.属性") }}：<span class="tx-white">{{
                        item.propertyValue
                      }}</span>
                    </div>
                    <div
                      v-if="item.itemSpecific && item.itemSpecific.length"
                      class="tx-ellipsis1"
                    >
                      <a
                        class="tx-info"
                        href="javascript:;"
                        @click="openSpecifics(item.itemSpecific)"
                        >{{ $t("product.更多扩展属性") }}</a
                      >
                    </div>
                    <div v-if="item.categoryPath" class="tx-ellipsis1">
                      {{ $t("product.分类") }}：<span class="tx-white">{{
                        item.categoryPath
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-4">
                <div>
                  {{ $t("product.销售价格") }}：<span class="tx-white"
                    >{{ $t("product.￥") }} {{ minPrice(item) }} ~{{
                      $t("product.￥")
                    }}
                    {{ maxPrice(item) }}</span
                  >
                </div>
                <div>
                  {{ $t("product.7天/30天销量") }}：<span class="tx-white"
                    >{{ item.sold7days }} / {{ item.sold30days }}</span
                  >
                </div>
                <div>
                  {{ $t("product.客户") }}SKU:
                  <span v-if="item.virtualSku.length" class="tx-white">
                    <template v-for="(vSku, vI) in item.virtualSku">
                      <span v-if="vI < 6" :key="vSku.id">
                        {{ vSku.virtualSku }}
                        <template v-if="vI < item.virtualSku.length - 1">
                          ，
                        </template>
                      </span>
                    </template>
                    <span v-if="item.virtualSku.length > 5">
                      {{ $t("product.等") }}
                      <a
                        class="tx-info"
                        href="javascript:;"
                        @click="openVirtualSku(item)"
                        >{{ item.virtualSku.length }}</a
                      >
                      {{ $t("product.个") }}
                    </span>
                  </span>
                  <span v-else>---</span>
                </div>
              </div>
              <div class="c-5">
                <div class="d-flex">
                  <div class="mg-r-25">
                    {{ $t("product.成本价") }}：
                    <span v-if="$store.state.amountStatus != '1'">
                        ******
                    </span>
                    <span v-else>
                      <span v-if="Number(item.price)" class="tx-white"
                        >{{ $t("product.￥")
                        }}{{ formatNum(item.price, 4) }}</span
                      >
                      <span v-else>--</span>
                    </span>
                  </div>
                  <div>
                    {{ $t("product.重量") }}：
                    <span v-if="Number(item.weight)" class="tx-white"
                      >{{ item.weight }}{{ $t("product.克") }}</span
                    >
                    <span v-else>--</span>
                  </div>
                </div>
                <div>
                  {{ $t("product.库存总量") }}：
                  <span class="tx-white">{{
                    item.totalInventory ? item.totalInventory : "--"
                  }}</span>
                </div>
                <div>
                  {{ $t("product.已发货量") }}(7/14/21/28)：
                  <span class="tx-white">
                    {{ item.shipped7 }} / {{ item.shipped14 }} /
                    {{ item.shipped21 }} /
                    {{ item.shipped28 }}
                  </span>
                </div>
                <div>
                  {{ $t("product.预测日销量") }}：<span class="tx-white">{{
                    item.forecastDaySales ? item.forecastDaySales : "---"
                  }}</span>
                </div>
                <div v-if="item.processGroupName">
                  {{ item.processGroupName }}
                </div>
              </div>
              <div class="c-2 tx-g">
                <div>
                  <span
                    :class="item.status == 2 ? 'tx-danger' : 'tx-success'"
                    >{{ $t(status[item.status]) }}</span
                  >
                </div>
                <div v-if="item.processGroupName">
                  {{ item.processGroupName }}
                </div>
              </div>
              <div class="c-3">
                 <div>
                  {{item.reason}}
                </div>
                <a
                  v-if="
                    item.productRemark || item.saleRemark || item.purchaseRemark
                  "
                  class="pd-5 tx-info"
                  href="javascript:;"
                  data-container="body"
                  data-toggle="tooltip-primary"
                  data-placement="top"
                  data-html="true"
                  style="margin-left: 15px;"
                  :data-original-title="remarkFormat(item)"
                  @click="openLog(index)"
                >
                  <i class="icon ion-chatbox-working tx-20 tx-info"></i>
                </a>
                <a v-else href="javascript:;" class="op-6" style="margin-left: 15px;">
                  <i class="icon ion-chatbox-working tx-20 tx-gray-600"></i>
                </a>
             
              </div>
              <div class="c-3">
                <div>  <img
                  v-if="item.checkFlag == 1"
                  src="./image/have-audited.png"
                  style="margin-left:15px;transform: rotate(45deg)"
                  width="50px"
                  height="50px"
                />
                <br />
                <img
                  v-if="item.checkFlag == 3 "
                  src="./image/rolremovebg-preview.png"
                  style="margin-left:15px;transform: rotate(10deg)"
                  width="50px"
                  height="50px"
                /></div>
                <template v-if="!item.notChange">
                  <div v-if="$route.query.source == 'new-products'">
                    <a
                      class="btn btn-sm btn-info"
                      href="javascript:;"
                      @click="selectNewProduct(item.sku)"
                    >
                      {{ $t("product.选为新品推荐") }}
                    </a>
                  </div>
                  <template v-else>
                    <div>
                      <router-link
                        class="mg-r-15 tx-info"
                        :to="{
                          name: 'editProduct',
                          query: { id: item.id, changeType: item.skuType },
                        }"
                        target="_blank"
                        @click="addNewOrder(index)"
                        >{{ $t("product.编辑") }}</router-link
                      >
                      <router-link
                        class="tx-info"
                        :to="{
                          name: 'editProduct',
                          query: { copyId: item.id, changeType: item.skuType },
                        }"
                        target="_blank"
                        @click="addNewOrder(index, 'copy')"
                        >{{ $t("product.复制") }}</router-link
                      >
                    </div>
                    <div>
                      <template v-if="item.skuType != 5">
                        <a
                          v-if="item.status != 2"
                          class="mg-r-15 tx-danger"
                          href="javascript:;"
                          @click="changeStatus(index, '2')"
                          >{{ $t("product.停止销售") }}</a
                        >
                        <a
                          v-if="item.status == 2"
                          class="mg-r-15 tx-info"
                          href="javascript:;"
                          @click="changeStatus(index, '1')"
                          >{{ $t("product.开启正常销售") }}</a
                        >
                      </template>
                      <a
                        v-if="userinfo.notSupplyChangeInfo != 1"
                        class="tx-danger"
                        href="javascript:;"
                        @click="delProModal(index)"
                        >{{ $t("product.删除") }}</a
                      >
                    </div>
                    <div
                      v-if="
                        item.skuType == 1 &&
                        !$root.$children[0].userInfo.rootUrl
                      "
                    >
                      <a
                        class="tx-info"
                        href="javascript:;"
                        @click="setSkuType(index, '')"
                        >{{ $t("product.设为电子券类型") }}</a
                      >
                    </div>
                    <div
                      v-if="
                        item.skuType == 3 &&
                        !$root.$children[0].userInfo.rootUrl
                      "
                    >
                      <a
                        class="tx-info"
                        href="javascript:;"
                        @click="uploadSkuType(item.id)"
                        >{{ $t("product.上传电子券") }}excel</a
                      >
                    </div>
                    <div
                      v-if="
                        item.skuType == 3 &&
                        !$root.$children[0].userInfo.rootUrl
                      "
                    >
                      <a
                        class="tx-info"
                        href="javascript:;"
                        @click="checkSkuType(item.sku)"
                        >{{ $t("product.查看电子商品码") }}</a
                      >
                    </div>
                    <div>
                      <a
                        v-if="userinfo.notSupplyChangeInfo != 1"
                        class="tx-info"
                        href="javascript:;"
                        @click="mergeProTemp(item)"
                        >{{ $t("product.加入待合并清单") }}</a
                      >
                    </div>
                    
                  </template>
                </template>
              </div>
            </div>
            <div class="mg-t-5">
              <a
                style="margin-left: 6px"
                v-if="item.categoryTags && item.categoryTags.length > 0"
                class="tx-info mg-r-20"
                href="javascript:;"
                @mouseenter="popContact($event, index, 'categoryTags')"
                @mouseleave="popContact($event)"
              >
                <span
                  style="
                    padding: 1px 2px;
                    border: 1px solid rgb(23, 162, 184);
                    font-size: 12px;
                  "
                  >{{ $t("product.标签") }}</span
                >
              </a>
              <a
                v-if="
                  item.positions &&
                  item.positions.length > 0 &&
                  item.rawSkus &&
                  item.rawSkus.length == 0
                "
                @click="innerTableStatus(index)"
                href="javascript:;"
                class="tx-info tx-underline tx-14"
              >
                <i
                  class="mg-x-5 fa tx-white tx-14"
                  :class="
                    openInner[index] ? 'fa-minus-square' : 'fa-plus-square'
                  "
                ></i
                >{{ $t("product.仓库仓位信息") }}
              </a>
            </div>
            <div v-if="openInner[index]">
              <table
                class="
                  table
                  mg-b-0
                  table-contact
                  product-table-inner
                  data-table
                "
              >
                <tbody>
                  <tr>
                    <td
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                      style="padding-left: 35px"
                    >
                      {{ $t("product.仓库【仓位】") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.库存量") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.警戒库存") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.操作") }}
                    </td>
                  </tr>
                  <tr
                    v-for="(position, positionindex) in item.positions"
                    :key="positionindex"
                  >
                    <td
                      class="
                        valign-middle
                        wd-lg-300
                        tx-12
                        text-left
                        pd-t-15 pd-b-15
                        pos-relative
                      "
                      style="padding-left: 35px"
                    >
                      <div>
                        <span class="tx-gray-300"
                          >{{ position.warehouseName }}[{{
                            position.name
                          }}]</span
                        >
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="tx-gray-300">{{
                          position.quantity ? position.quantity : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="tx-gray-300">{{
                          position.warningCnt ? position.warningCnt : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
                      <p class="mg-b-5">
                        <a
                          class="tx-underline tx-info tx-12"
                          href="javascript:;"
                          @click="changeWarehouse(item, position)"
                          >{{ $t("product.更换仓位") }}</a
                        >
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- list end -->
      </div>
      <table
        v-if="false"
        class="table mg-b-0 table-contact product-table data-table"
        id="productListTable"
      >
        <thead>
          <tr>
            <th class="wd-lg-300">
              <label class="ckbox mg-b-0 d-inline-block valign-middle">
                <input
                  type="checkbox"
                  :checked="isAll"
                  @change="changeAllCheck($event)"
                />
                <span></span>
              </label>
              {{ $t("product.商品信息") }}
            </th>
            <th class="wd-lg-200 tx-10-force tx-mont tx-medium hidden-xs-down">
              {{ $t("product.状态") }}
            </th>
            <th class="wd-lg-300 tx-10-force tx-mont tx-medium hidden-xs-down">
              <p class="mg-0">{{ $t("product.库存总量") }}</p>
              <p class="mg-0">{{ $t("product.未发数量") }}</p>
            </th>
            <th class="wd-lg-300 tx-10-force tx-mont tx-medium hidden-xs-down">
              <p class="mg-0">{{ $t("product.已发货量") }}(7/14/21/28)</p>
              <p class="mg-0">{{ $t("product.预测日销量") }}</p>
            </th>
            <th class="wd-lg-300 tx-10-force tx-mont tx-medium hidden-xs-down">
              <p class="mg-0">{{ $t("product.成本价（￥）") }}</p>
            </th>
            <th class="wd-lg-150 tx-10-force tx-mont tx-medium hidden-xs-down">
              {{ $t("product.操作") }}
            </th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in items" :key="index">
          <tr>
            <td
              class="
                valign-middle
                wd-lg-300
                tx-12
                text-left
                pd-t-15 pd-b-15
                pos-relative
              "
            >
              <div class="d-flex align-items-center">
                <label class="ckbox mg-b-0 d-inline-block valign-middle">
                  <input type="checkbox" :value="item.sku" v-model="checkArr" />
                  <span></span>
                </label>
                <a
                  class="p-img-wrap mg-x-5"
                  href="javascript:;"
                  v-lazy:background-image="item.propertyImage"
                  :data-i="index"
                  :style="{
                    backgroundSize: scale[index].scale ? 'auto 100%' : '100%',
                  }"
                  @click="preview(item.propertyImage, item.name)"
                >
                </a>
                <div class="p-info">
                  <div class="mg-b-5 d-flex align-items-center">
                    <p class="mg-b-5">
                      <span class="tx-white">{{ item.name }}</span>
                    </p>
                  </div>
                  <p class="mg-b-5">
                    {{ $t("product.重量") }}(g):
                    <span class="tx-white">{{ item.weight }}</span>
                  </p>
                  <p class="mg-b-5">
                    SKU:
                    <span class="tx-white mg-r-5">{{ item.sku }}</span>
                    <a
                      v-show="item.sku"
                      class="to-clipboard tx-info mg-l-5"
                      href="javascript:;"
                      :data-clipboard-text="item.sku"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </p>
                  <p class="mg-b-5" v-if="changeType == 1">
                    {{ $t("product.客户") }}SKU:
                    <span class="tx-white mg-r-5">{{ item.virtualSku }}</span>
                    <a
                      v-show="item.virtualSku"
                      class="to-clipboard tx-info mg-l-5"
                      href="javascript:;"
                      :data-clipboard-text="item.virtualSku"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </p>
                  <p class="mg-b-5">
                    {{ $t("product.分类") }}:
                    <span class="tx-white">{{ item.categoryPath }}</span>
                  </p>
                </div>
              </div>
              <div
                class="pd-l-30 mg-t-5"
                v-if="
                  item.positions &&
                  item.positions.length > 0 &&
                  item.rawSkus &&
                  item.rawSkus.length == 0
                "
              >
                <a
                  @click="innerTableStatus(index)"
                  href="javascript:;"
                  class="tx-info tx-underline tx-14"
                >
                  <i
                    class="fa tx-white tx-16"
                    :class="
                      openInner[index] ? 'fa-minus-square' : 'fa-plus-square'
                    "
                  ></i>
                  {{ $t("product.仓库仓位信息") }}
                </a>
              </div>
            </td>
            <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
              <div>
                <span :class="item.status == 2 ? 'tx-danger' : 'tx-success'">{{
                  $t(status[item.status])
                }}</span>
              </div>
            </td>
            <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
              <div>
                <span class="mg-r-5">{{ $t("product.库存总量") }}:</span>
                <span class="tx-gray-300">{{
                  item.totalInventory ? item.totalInventory : "---"
                }}</span>
              </div>
              <div>
                <span class="mg-r-5">{{ $t("product.未发数量") }}:</span>
                <span class="tx-gray-300">{{
                  item.totalWait ? item.totalWait : "---"
                }}</span>
              </div>
            </td>
            <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
              <div>
                <span class="mg-r-5"
                  >{{ $t("product.已发货量") }}（7/14/21/28）:</span
                >
                <span class="tx-gray-300">
                  {{ item.shipped7 }} / {{ item.shipped14 }} /
                  {{ item.shipped21 }} /
                  {{ item.shipped28 }}
                </span>
              </div>
              <div>
                <span class="mg-r-5">{{ $t("product.预测日销量") }}:</span>
                <span class="tx-gray-300">{{
                  item.forecastDaySales ? item.forecastDaySales : "---"
                }}</span>
              </div>
            </td>
            <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
              <div>
                <span class="mg-r-5">{{ $t("product.成本价") }}:</span>
                <span class="tx-gray-300">{{
                  item.price ? formatNum(item.price, 4) : "---"
                }}</span>
              </div>
            </td>
            <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
              <template v-if="!item.notChange">
                <div v-if="$route.query.source == 'new-products'">
                  <a
                    class="btn btn-sm btn-info"
                    href="javascript:;"
                    @click="selectNewProduct(item.sku)"
                  >
                    {{ $t("product.选为新品推荐") }}
                  </a>
                </div>
                <template v-else>
                  <p class="mg-b-5">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="addNewOrder(index)"
                      >{{ $t("product.编辑") }}</a
                    >
                  </p>
                  <p class="mg-b-5">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="addNewOrder(index, 'copy')"
                      >{{ $t("product.复制") }}</a
                    >
                  </p>
                  <p class="mg-b-5">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="openLog(index)"
                      >{{ $t("product.备注") }}</a
                    >
                  </p>
                  <p class="mg-b-5">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="delProModal(index)"
                      >{{ $t("product.删除") }}</a
                    >
                  </p>
                  <p class="mg-b-5" v-if="item.skuType == 1">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="setSkuType(index, '')"
                      >{{ $t("product.设置为电子券类型") }}</a
                    >
                  </p>
                  <p class="mg-b-5" v-if="item.skuType == 3">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="uploadSkuType(item.id)"
                      >{{ $t("product.上传电子券") }}excel</a
                    >
                  </p>
                  <p class="mg-b-5" v-if="item.skuType == 3">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="checkSkuType(item.sku)"
                      >{{ $t("product.查看电子商品码") }}</a
                    >
                  </p>
                  <p class="mg-b-0" v-if="item.skuType != 5">
                    <a
                      v-if="item.status != 2"
                      class="tx-underline tx-danger tx-12"
                      href="javascript:;"
                      @click="changeStatus(index, '2')"
                      >{{ $t("product.停止销售") }}</a
                    >
                    <a
                      v-if="item.status == 2"
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="changeStatus(index, '1')"
                      >{{ $t("product.开启正常销售") }}</a
                    >
                  </p>
                </template>
              </template>
            </td>
          </tr>
          <tr v-if="item.rawSkus && item.rawSkus.length > 0">
            <td
              colspan="6"
              class="pd-l-30"
              style="padding-top: 0; padding-bottom: 0; border-top: none"
            >
              <div class="pd-l-30">
                <a
                  @click="innerTableStatus2(index)"
                  href="javascript:;"
                  class="tx-info tx-underline tx-14"
                >
                  <i
                    class="fa tx-white tx-16"
                    :class="
                      openInner2[index] ? 'fa-minus-square' : 'fa-plus-square'
                    "
                  ></i>
                  {{ $t("product.原料商品信息") }}
                </a>
              </div>
            </td>
          </tr>
          <tr
            :style="{ display: openInner2[index] ? 'table-row' : 'none' }"
            class="collapse"
          >
            <td class="inner-wrap tx-12" colspan="6">
              <table
                class="
                  table
                  mg-b-0
                  table-contact
                  product-table-inner
                  data-table
                "
              >
                <thead>
                  <tr>
                    <th
                      class="wd-lg-300"
                      style="
                        padding-left: 30px;
                        color: #868ba1;
                        font-weight: normal;
                      "
                    >
                      {{ $t("product.商品信息") }}
                    </th>
                    <th
                      class="
                        wd-lg-200
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      {{ $t("product.状态") }}
                    </th>
                    <th
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      <p class="mg-0">{{ $t("product.库存总量") }}</p>
                      <p class="mg-0">{{ $t("product.未发数量") }}</p>
                    </th>
                    <th
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      <p class="mg-0">{{ $t("product.数量") }}</p>
                    </th>
                    <th
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      <p class="mg-0">{{ $t("product.成本价（￥）") }}</p>
                    </th>
                    <th
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      {{ $t("product.操作") }}
                    </th>
                  </tr>
                </thead>
                <tbody v-for="(rawSku, i) in item.rawSkus" :key="i">
                  <tr>
                    <td
                      class="
                        valign-middle
                        wd-lg-300
                        tx-12
                        text-left
                        pd-t-15 pd-b-15 pd-l-0
                        pos-relative
                      "
                    >
                      <div class="d-flex align-items-center pd-l-25">
                        <a
                          class="p-img-wrap mg-x-5"
                          href="javascript:;"
                          v-lazy:background-image="rawSku.propertyImage"
                          :data-i="i"
                          style="
                            background-size: cover;
                            background-position: center;
                          "
                          @click="preview(rawSku.propertyImage, rawSku.name)"
                        >
                        </a>
                        <div class="p-info">
                          <p class="mg-b-5 d-flex align-items-center"></p>
                          <p class="mg-b-5">
                            <span class="tx-white">{{ rawSku.name }}</span>
                          </p>

                          <p class="mg-b-5">
                            {{ $t("product.重量") }}(g):
                            <span class="tx-white">{{ rawSku.weight }}</span>
                          </p>
                          <p class="mg-b-5">
                            SKU:
                            <span class="tx-white mg-r-5">{{
                              rawSku.sku
                            }}</span>
                            <a
                              v-show="rawSku.sku"
                              class="to-clipboard tx-info mg-l-5"
                              href="javascript:;"
                              :data-clipboard-text="rawSku.sku"
                            >
                              <i class="icon ion-clipboard"></i>
                            </a>
                          </p>
                          <p class="mg-b-5">
                            {{ $t("product.分类") }}:
                            <span class="tx-white">{{
                              rawSku.categoryPath
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span
                          :class="
                            rawSku.status == 2 ? 'tx-danger' : 'tx-success'
                          "
                          >{{ $t(status[rawSku.status]) }}</span
                        >
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="mg-r-5"
                          >{{ $t("product.库存总量") }}:</span
                        >
                        <span class="tx-gray-300">{{
                          rawSku.totalInventory ? rawSku.totalInventory : "---"
                        }}</span>
                      </div>
                      <div>
                        <span class="mg-r-5"
                          >{{ $t("product.未发数量") }}:</span
                        >
                        <span class="tx-gray-300">{{
                          rawSku.totalWait ? rawSku.totalWait : "---"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="mg-r-5">{{ $t("product.数量") }}:</span>
                        <span class="tx-gray-300">{{
                          rawSku.quantity ? rawSku.quantity : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="mg-r-5">{{ $t("product.成本价") }}:</span>
                        <span class="tx-gray-300">{{
                          rawSku.price ? formatNum(rawSku.price, 4) : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
                      <p class="mg-b-5">
                        <a
                          class="tx-underline tx-info tx-12"
                          href="javascript:;"
                          @click="editQuantityRaw(index, i)"
                          >{{ $t("product.修改数量") }}</a
                        >
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr
            v-if="
              item.positions &&
              item.positions.length > 0 &&
              item.rawSkus &&
              item.rawSkus.length > 0
            "
          >
            <td
              colspan="6"
              class="pd-l-30"
              style="padding-top: 0; padding-bottom: 0; border-top: none"
            >
              <div class="pd-l-30">
                <a
                  @click="innerTableStatus(index)"
                  href="javascript:;"
                  class="tx-info tx-underline tx-14"
                >
                  <i
                    class="fa tx-white tx-16"
                    :class="
                      openInner[index] ? 'fa-minus-square' : 'fa-plus-square'
                    "
                  ></i>
                  {{ $t("product.仓库仓位信息") }}
                </a>
              </div>
            </td>
          </tr>
          <tr
            :style="{ display: openInner[index] ? 'table-row' : 'none' }"
            class="collapse"
          >
            <td class="inner-wrap tx-12" colspan="6">
              <table
                class="
                  table
                  mg-b-0
                  table-contact
                  product-table-inner
                  data-table
                "
              >
                <tbody>
                  <tr>
                    <td
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                      style="padding-left: 35px"
                    >
                      {{ $t("product.仓库【仓位】") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.库存量") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.警戒库存") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.操作") }}
                    </td>
                  </tr>
                  <tr
                    v-for="(position, positionindex) in item.positions"
                    :key="positionindex"
                  >
                    <td
                      class="
                        valign-middle
                        wd-lg-300
                        tx-12
                        text-left
                        pd-t-15 pd-b-15
                        pos-relative
                      "
                      style="padding-left: 35px"
                    >
                      <div>
                        <span class="tx-gray-300"
                          >{{ position.warehouseName }}[{{
                            position.name
                          }}]</span
                        >
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="tx-gray-300">{{
                          position.quantity ? position.quantity : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="tx-gray-300">{{
                          position.warningCnt ? position.warningCnt : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
                      <p class="mg-b-5">
                        <a
                          class="tx-underline tx-info tx-12"
                          href="javascript:;"
                          @click="changeWarehouse(item, position)"
                          >{{ $t("product.更换仓位") }}</a
                        >
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-show="(!items || items.length < 1) && !first_loading"
        class="nodata mg-t-50 mg-b-50 text-center tx-24"
      >
        <i class="fa fa-ban"></i>{{ $t("product.没有符合条件的库存商品") }}
      </div>
    </div>
    <!-- 工艺管理 -->
    <div class="body-bg card bd-gray-400" v-if="changeType == 99">
      <div class="list-wrap mg-b-15">
        <!-- header -->
        <div class="list-heard d-flex mg-b-5">
          <div class="pd-l-5 d-flex justify-content-center">
            <label class="ckbox">
              <input
                type="checkbox"
                :checked="isAllGong"
                @change="changeAllCheckGong($event)"
              />
              <span></span>
            </label>
          </div>
          <div class="d-flex pd-x-5 flex-1">
            <div class="c-7 tx-white">{{ $t("product.工艺信息") }}</div>
            <div class="c-5 tx-white">{{ $t("product.工艺成本") }}</div>
            <div class="c-7 tx-white">{{ $t("product.当前工艺组") }}</div>
            <div class="c-2 tx-white">{{ $t("product.备注") }}</div>
            <div class="c-3 tx-white">{{ $t("product.操作") }}</div>
          </div>
        </div>
        <!-- header end -->
        <!-- list -->
        <div
          v-for="(item, index) in items"
          :key="item.id"
          class="list-body d-flex mg-b-10"
        >
          <div class="pd-l-5 d-flex justify-content-center">
            <label class="ckbox mg-b-0">
              <input
                type="checkbox"
                :value="item.id"
                v-model="checkArrGong"
              /><span></span>
            </label>
          </div>
          <div class="flex-1 pd-x-5 product-table card bd-gray-400 pd-5">
            <div class="d-flex align-items-center">
              <!-- 工艺信息 -->
              <div class="c-7">
                <div class="d-flex overflow-hidden">
                  <div class="pro-info">
                    <div class="tx-ellipsis2">
                      {{ $t("product.工艺名称") }}：
                      <span class="tx-white">{{ item.name }}</span>
                    </div>
                    <div class="tx-ellipsis2">
                      {{ $t("product.工艺描述") }}：
                      <span class="tx-white">{{ item.desc }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 工艺成本 -->
              <div class="c-5">
                <div>
                  {{ $t("product.加工费用") }}：
                  <span class="tx-white"
                    >{{ $t("product.￥") }}
                    {{ Number(item.price).toFixed(2) }}</span
                  >
                </div>
                <div>
                  {{ $t("product.加工时长") }}：
                  <span class="tx-white">{{ item.productionDuration }}</span>
                </div>
              </div>
              <!-- 当前工艺组 -->
              <div class="c-7">
                <!-- <div> -->
                <div
                  class="tx-white"
                  v-for="(group, ids) in item.groups"
                  :key="ids"
                >
                  {{ group.name }}
                </div>
                <!-- </div> -->
              </div>
              <!-- 备注 -->
              <div class="c-2">
                <a
                  v-if="item.desc"
                  class="pd-5 tx-info"
                  href="javascript:;"
                  data-container="body"
                  data-toggle="tooltip-primary"
                  data-placement="top"
                  data-html="true"
                  :data-original-title="getDesc(item)"
                >
                  <i class="icon ion-chatbox-working tx-20 tx-info"></i>
                </a>
                <a v-else href="javascript:;" class="op-6">
                  <i class="icon ion-chatbox-working tx-20 tx-gray-600"></i>
                </a>
              </div>
              <!-- 操作 -->
              <div class="c-3">
                <div>
                  <router-link
                    class="mg-r-15 tx-info"
                    :to="{
                      name: 'editCraft',
                      query: { id: item.id, changeType: 99 },
                    }"
                    target="_blank"
                    >{{ $t("product.编辑") }}</router-link
                  >
                </div>
                <div>
                  <a
                    v-if="userinfo.notSupplyChangeInfo != 1"
                    class="tx-danger"
                    href="javascript:;"
                    @click="delCraft(item, index)"
                    >{{ $t("product.删除") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- list end -->
      </div>
      <!-- 没有符合条件的库存商品 -->
      <div
        v-show="(!items || items.length < 1) && !first_loading"
        class="nodata mg-t-50 mg-b-50 text-center tx-24"
      >
        <i class="fa fa-ban"></i>{{ $t("product.没有符合条件的库存商品") }}
      </div>
    </div>
    <div class="body-bg card bd-gray-400" v-if="changeType == 5">
      <!-- new list -->
      <div v-if="1" class="list-wrap mg-b-15">
        <!-- header -->
        <div class="list-heard d-flex mg-b-5">
          <div class="pd-l-5 d-flex justify-content-center">
            <label class="ckbox">
              <input
                type="checkbox"
                :checked="isAll"
                @change="changeAllCheck($event)"
              />
              <span></span>
            </label>
          </div>
          <div class="d-flex pd-x-5 flex-1">
            <div class="c-7 tx-white">{{ $t("product.商品信息") }}</div>
            <div class="c-5 tx-white">{{ $t("product.生产信息") }}</div>
            <div class="c-6 tx-white">{{ $t("product.关联材料/供应商") }}</div>
            <div class="c-2 tx-white">{{ $t("product.状态") }}</div>
            <div class="c-1 tx-white">{{ $t("product.备注") }}</div>
            <div class="c-3 tx-white">{{ $t("product.操作") }}</div>
          </div>
        </div>
        <!-- header end -->
        <!-- list -->
        <div
          v-for="(item, index) in items"
          :key="item.id"
          class="list-body d-flex mg-b-10"
        >
          <div class="pd-l-5 d-flex justify-content-center">
            <label class="ckbox mg-b-0">
              <input
                type="checkbox"
                :value="item.sku"
                v-model="checkArr"
              /><span></span>
            </label>
          </div>
          <div class="flex-1 pd-x-5 product-table card bd-gray-400 pd-5">
            <div class="d-flex align-items-center">
              <div class="c-7">
                <div class="d-flex overflow-hidden">
                  <a
                    class="mg-r-10 img-wrap d-block"
                    href="javascript:;"
                    :class="{ isIll: $isIll(item.propertyImage) }"
                    v-lazy:background-image="item.propertyImage"
                    @click="preview(item.propertyImage, item.name)"
                  ></a>
                  <div class="pro-info">
                    <div class="tx-ellipsis2">
                      {{ $t("product.商品标题") }}：
                      <span class="tx-white">{{ item.name }}</span>
                    </div>
                    <div class="">
                      <div v-if="item.sku">
                        SKU：
                        <span class="tx-white">
                          {{ item.sku }}
                          <a
                            href="javascript:;"
                            class="tx-info to-clipboard"
                            :data-clipboard-text="item.sku"
                          >
                            <i class="icon ion-clipboard"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                    <div v-if="item.skuType" class="tx-ellipsis1">
                      {{ $t("product.原料属性") }}：
                      <span class="tx-white" v-if="item.skuType == '5'">{{
                        $t("product.原材料")
                      }}</span>
                      <span class="tx-white" v-if="item.skuType == '7'">{{
                        $t("product.半成品")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 生产信息 -->
              <div class="c-5">
                <div>
                  {{ $t("product.成本价格") }}：
                  <span class="tx-white"
                    >{{ $t("product.￥") }} {{ formatNum(item.price, 4) }}</span
                  >
                </div>
                <div>
                  {{ $t("product.产品重量") }}：
                  <span class="tx-white">{{
                    Number(item.weight).toFixed(2)
                  }}</span>
                </div>
                <div>
                  {{ $t("product.库存数量") }}：
                  <span class="tx-white">{{
                    Number(item.quantity).toFixed(0)
                  }}</span>
                </div>
                <div v-if="item.skuType == '7'">
                  {{ $t("product.生产时间") }}：
                  <span class="tx-white">{{ item.productionDuration }}</span>
                </div>
                <div v-if="item.skuType == '5'">
                  {{ $t("product.购买时间") }}：
                  <span class="tx-white">{{ item.purchaseDuration }}</span>
                </div>
              </div>
              <!-- 关联材料/供应商 -->
              <div class="c-6 mb-2">
                <div class="">
                  <div v-if="item.childStocks && item.skuType == '7'">
                    <div
                      v-for="(material, index) in item.childStocks.slice(0, 3)"
                      :key="index"
                    >
                      <span
                        >{{ $t("product.材料SKU") }}：{{ material.sku }}</span
                      >
                      <span class="ml-md-4"
                        >{{ $t("product.数量") }}：{{
                          Number(material.num).toFixed(0)
                        }}</span
                      >
                    </div>
                    <div
                      v-if="item.childStocks.length > 0"
                      class="pt-t-10 ft-bold cur-pt"
                      @click="checkMaterials(item)"
                    >
                      . . .
                    </div>
                  </div>

                  <div v-if="item.defaultRawStockSupplier">
                    <div>
                      <span>{{ $t("product.供应商：") }}</span>
                      <span>{{ item.defaultRawStockSupplier }}</span>
                    </div>
                    <div>
                      <span>{{ $t("product.采购价：") }}</span>
                      <span
                        >{{ $t("product.￥")
                        }}{{
                          formatNum(item.defaultRawStockSupplierPrice, 4)
                        }}</span
                      >
                    </div>
                    <span
                      v-if="item.defaultRawStockSupplier"
                      class="pt-t-10 cur-pt text-primary"
                      @click="checkMoreSupplier(item)"
                      >{{ $t("product.点击查看更多") }}</span
                    >
                  </div>
                </div>
              </div>
              <!-- 状态 -->
              <div class="c-2 tx-g">
                <div>
                  <span
                    :class="item.status == 2 ? 'tx-danger' : 'tx-success'"
                    >{{ $t(status[item.status]) }}</span
                  >
                </div>
                <div v-if="item.skuType == '7' && item.processGroupName">
                  {{ item.processGroupName }}
                </div>
                <div></div>
              </div>
              <!-- 备注 -->
              <div class="c-1">
                <a
                  v-if="
                    item.productRemark || item.saleRemark || item.purchaseRemark
                  "
                  class="pd-5 tx-info"
                  href="javascript:;"
                  data-container="body"
                  data-toggle="tooltip-primary"
                  data-placement="top"
                  data-html="true"
                  :data-original-title="remarkFormat(item)"
                  @click="openLog(index)"
                >
                  <i class="icon ion-chatbox-working tx-20 tx-info"></i>
                </a>
                <a v-else href="javascript:;" class="op-6">
                  <i class="icon ion-chatbox-working tx-20 tx-gray-600"></i>
                </a>
              </div>
              <!-- 操作 -->
              <div class="c-3">
                <template v-if="!item.notChange">
                  <div v-if="$route.query.source == 'new-products'">
                    <a
                      class="btn btn-sm btn-info"
                      href="javascript:;"
                      @click="selectNewProduct(item.sku)"
                    >
                      {{ $t("product.选为新品推荐") }}
                    </a>
                  </div>
                  <template v-else>
                    <div>
                      <router-link
                        class="mg-r-15 tx-info"
                        :to="{
                          name: 'editProducts',
                          query: { id: item.id, changeType: 5 },
                        }"
                        target="_blank"
                        @click="addNewOrder(index)"
                        >{{ $t("product.编辑") }}</router-link
                      >
                    </div>
                    <div>
                      <a
                        v-if="userinfo.notSupplyChangeInfo != 1"
                        class="tx-danger"
                        href="javascript:;"
                        @click="delProModal(index)"
                        >{{ $t("product.删除") }}</a
                      >
                    </div>
                  </template>
                </template>
              </div>
            </div>
            <div class="mg-t-5">
              <a
                style="margin-left: 6px"
                v-if="item.categoryTags && item.categoryTags.length > 0"
                class="tx-info mg-r-20"
                href="javascript:;"
                @mouseenter="popContact($event, index, 'categoryTags')"
                @mouseleave="popContact($event)"
              >
                <span
                  style="
                    padding: 1px 2px;
                    border: 1px solid rgb(23, 162, 184);
                    font-size: 12px;
                  "
                  >{{ $t("product.标签") }}</span
                >
              </a>
              <a
                v-if="
                  item.positions &&
                  item.positions.length > 0 &&
                  item.rawSkus &&
                  item.rawSkus.length == 0
                "
                @click="innerTableStatus(index)"
                href="javascript:;"
                class="tx-info tx-underline tx-14"
              >
                <i
                  class="mg-x-5 fa tx-white tx-14"
                  :class="
                    openInner[index] ? 'fa-minus-square' : 'fa-plus-square'
                  "
                ></i
                >{{ $t("product.仓库仓位信息") }}
              </a>
            </div>
            <div v-if="openInner[index]">
              <table
                class="
                  table
                  mg-b-0
                  table-contact
                  product-table-inner
                  data-table
                "
              >
                <tbody>
                  <tr>
                    <td
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                      style="padding-left: 35px"
                    >
                      {{ $t("product.仓库【仓位】") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.库存量") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.警戒库存") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.操作") }}
                    </td>
                  </tr>
                  <tr
                    v-for="(position, positionindex) in item.positions"
                    :key="positionindex"
                  >
                    <td
                      class="
                        valign-middle
                        wd-lg-300
                        tx-12
                        text-left
                        pd-t-15 pd-b-15
                        pos-relative
                      "
                      style="padding-left: 35px"
                    >
                      <div>
                        <span class="tx-gray-300"
                          >{{ position.warehouseName }}[{{
                            position.name
                          }}]</span
                        >
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="tx-gray-300">{{
                          position.quantity ? position.quantity : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="tx-gray-300">{{
                          position.warningCnt ? position.warningCnt : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
                      <p class="mg-b-5">
                        <a
                          class="tx-underline tx-info tx-12"
                          href="javascript:;"
                          @click="changeWarehouse(item, position)"
                          >{{ $t("product.更换仓位") }}</a
                        >
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- list end -->
      </div>
      <table
        v-if="false"
        class="table mg-b-0 table-contact product-table data-table"
        id="productListTable"
      >
        <thead>
          <tr>
            <th class="wd-lg-300">
              <label class="ckbox mg-b-0 d-inline-block valign-middle">
                <input
                  type="checkbox"
                  :checked="isAll"
                  @change="changeAllCheck($event)"
                />
                <span></span>
              </label>
              {{ $t("product.商品信息") }}
            </th>
            <th class="wd-lg-200 tx-10-force tx-mont tx-medium hidden-xs-down">
              {{ $t("product.状态") }}
            </th>
            <th class="wd-lg-300 tx-10-force tx-mont tx-medium hidden-xs-down">
              <p class="mg-0">{{ $t("product.库存总量") }}</p>
              <p class="mg-0">{{ $t("product.未发数量") }}</p>
            </th>
            <th class="wd-lg-300 tx-10-force tx-mont tx-medium hidden-xs-down">
              <p class="mg-0">{{ $t("product.已发货量") }}(7/14/21/28)</p>
              <p class="mg-0">{{ $t("product.预测日销量") }}</p>
            </th>
            <th class="wd-lg-300 tx-10-force tx-mont tx-medium hidden-xs-down">
              <p class="mg-0">{{ $t("product.成本价（￥）") }}</p>
            </th>
            <th class="wd-lg-150 tx-10-force tx-mont tx-medium hidden-xs-down">
              {{ $t("product.操作") }}
            </th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in items" :key="index">
          <tr>
            <td
              class="
                valign-middle
                wd-lg-300
                tx-12
                text-left
                pd-t-15 pd-b-15
                pos-relative
              "
            >
              <div class="d-flex align-items-center">
                <label class="ckbox mg-b-0 d-inline-block valign-middle">
                  <input type="checkbox" :value="item.sku" v-model="checkArr" />
                  <span></span>
                </label>
                <a
                  class="p-img-wrap mg-x-5"
                  href="javascript:;"
                  v-lazy:background-image="item.propertyImage"
                  :data-i="index"
                  :style="{
                    backgroundSize: scale[index].scale ? 'auto 100%' : '100%',
                  }"
                  @click="preview(item.propertyImage, item.name)"
                >
                </a>
                <div class="p-info">
                  <div class="mg-b-5 d-flex align-items-center">
                    <p class="mg-b-5">
                      <span class="tx-white">{{ item.name }}</span>
                    </p>
                  </div>
                  <p class="mg-b-5">
                    {{ $t("product.重量") }}(g):
                    <span class="tx-white">{{ item.weight }}</span>
                  </p>
                  <p class="mg-b-5">
                    SKU:
                    <span class="tx-white mg-r-5">{{ item.sku }}</span>
                    <a
                      v-show="item.sku"
                      class="to-clipboard tx-info mg-l-5"
                      href="javascript:;"
                      :data-clipboard-text="item.sku"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </p>
                  <p class="mg-b-5" v-if="changeType == 1">
                    {{ $t("product.客户") }}SKU:
                    <span class="tx-white mg-r-5">{{ item.virtualSku }}</span>
                    <a
                      v-show="item.virtualSku"
                      class="to-clipboard tx-info mg-l-5"
                      href="javascript:;"
                      :data-clipboard-text="item.virtualSku"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </p>
                  <p class="mg-b-5">
                    {{ $t("product.分类") }}:
                    <span class="tx-white">{{ item.categoryPath }}</span>
                  </p>
                </div>
              </div>
              <div
                class="pd-l-30 mg-t-5"
                v-if="
                  item.positions &&
                  item.positions.length > 0 &&
                  item.rawSkus &&
                  item.rawSkus.length == 0
                "
              >
                <a
                  @click="innerTableStatus(index)"
                  href="javascript:;"
                  class="tx-info tx-underline tx-14"
                >
                  <i
                    class="fa tx-white tx-16"
                    :class="
                      openInner[index] ? 'fa-minus-square' : 'fa-plus-square'
                    "
                  ></i>
                  {{ $t("product.仓库仓位信息") }}
                </a>
              </div>
            </td>
            <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
              <div>
                <span :class="item.status == 2 ? 'tx-danger' : 'tx-success'">{{
                  $t(status[item.status])
                }}</span>
              </div>
            </td>
            <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
              <div>
                <span class="mg-r-5">{{ $t("product.库存总量") }}:</span>
                <span class="tx-gray-300">{{
                  item.totalInventory ? item.totalInventory : "---"
                }}</span>
              </div>
              <div>
                <span class="mg-r-5">{{ $t("product.未发数量") }}:</span>
                <span class="tx-gray-300">{{
                  item.totalWait ? item.totalWait : "---"
                }}</span>
              </div>
            </td>
            <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
              <div>
                <span class="mg-r-5"
                  >{{ $t("product.已发货量") }}（7/14/21/28）:</span
                >
                <span class="tx-gray-300">
                  {{ item.shipped7 }} / {{ item.shipped14 }} /
                  {{ item.shipped21 }} /
                  {{ item.shipped28 }}
                </span>
              </div>
              <div>
                <span class="mg-r-5">{{ $t("product.预测日销量") }}:</span>
                <span class="tx-gray-300">{{
                  item.forecastDaySales ? item.forecastDaySales : "---"
                }}</span>
              </div>
            </td>
            <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
              <div>
                <span class="mg-r-5">{{ $t("product.成本价") }}:</span>
                <span class="tx-gray-300">{{
                  item.price ? Number(item.price).toFixed(2) : "---"
                }}</span>
              </div>
            </td>
            <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
              <template v-if="!item.notChange">
                <div v-if="$route.query.source == 'new-products'">
                  <a
                    class="btn btn-sm btn-info"
                    href="javascript:;"
                    @click="selectNewProduct(item.sku)"
                  >
                    {{ $t("product.选为新品推荐") }}
                  </a>
                </div>
                <template v-else>
                  <p class="mg-b-5">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="addNewOrder(index)"
                      >{{ $t("product.编辑") }}</a
                    >
                  </p>
                  <p class="mg-b-5">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="addNewOrder(index, 'copy')"
                      >{{ $t("product.复制") }}</a
                    >
                  </p>
                  <p class="mg-b-5">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="openLog(index)"
                      >{{ $t("product.备注") }}</a
                    >
                  </p>
                  <p class="mg-b-5">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="delProModal(index)"
                      >{{ $t("product.删除") }}</a
                    >
                  </p>
                  <p class="mg-b-5" v-if="item.skuType == 1">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="setSkuType(index, '')"
                      >{{ $t("product.设置为电子券类型") }}</a
                    >
                  </p>
                  <p class="mg-b-5" v-if="item.skuType == 3">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="uploadSkuType(item.id)"
                      >{{ $t("product.上传电子券") }}excel</a
                    >
                  </p>
                  <p class="mg-b-5" v-if="item.skuType == 3">
                    <a
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="checkSkuType(item.sku)"
                      >{{ $t("product.查看电子商品码") }}</a
                    >
                  </p>
                  <p class="mg-b-0" v-if="item.skuType != 5">
                    <a
                      v-if="item.status != 2"
                      class="tx-underline tx-danger tx-12"
                      href="javascript:;"
                      @click="changeStatus(index, '2')"
                      >{{ $t("product.停止销售") }}</a
                    >
                    <a
                      v-if="item.status == 2"
                      class="tx-underline tx-info tx-12"
                      href="javascript:;"
                      @click="changeStatus(index, '1')"
                      >{{ $t("product.开启正常销售") }}</a
                    >
                  </p>
                </template>
              </template>
            </td>
          </tr>
          <tr v-if="item.rawSkus && item.rawSkus.length > 0">
            <td
              colspan="6"
              class="pd-l-30"
              style="padding-top: 0; padding-bottom: 0; border-top: none"
            >
              <div class="pd-l-30">
                <a
                  @click="innerTableStatus2(index)"
                  href="javascript:;"
                  class="tx-info tx-underline tx-14"
                >
                  <i
                    class="fa tx-white tx-16"
                    :class="
                      openInner2[index] ? 'fa-minus-square' : 'fa-plus-square'
                    "
                  ></i>
                  {{ $t("product.原料商品信息") }}
                </a>
              </div>
            </td>
          </tr>
          <tr
            :style="{ display: openInner2[index] ? 'table-row' : 'none' }"
            class="collapse"
          >
            <td class="inner-wrap tx-12" colspan="6">
              <table
                class="
                  table
                  mg-b-0
                  table-contact
                  product-table-inner
                  data-table
                "
              >
                <thead>
                  <tr>
                    <th
                      class="wd-lg-300"
                      style="
                        padding-left: 30px;
                        color: #868ba1;
                        font-weight: normal;
                      "
                    >
                      {{ $t("product.商品信息") }}
                    </th>
                    <th
                      class="
                        wd-lg-200
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      {{ $t("product.状态") }}
                    </th>
                    <th
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      <p class="mg-0">{{ $t("product.库存总量") }}</p>
                      <p class="mg-0">{{ $t("product.未发数量") }}</p>
                    </th>
                    <th
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      <p class="mg-0">{{ $t("product.数量") }}</p>
                    </th>
                    <th
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      <p class="mg-0">{{ $t("product.成本价（￥）") }}</p>
                    </th>
                    <th
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                      "
                      style="color: #868ba1; font-weight: normal"
                    >
                      {{ $t("product.操作") }}
                    </th>
                  </tr>
                </thead>
                <tbody v-for="(rawSku, i) in item.rawSkus" :key="i">
                  <tr>
                    <td
                      class="
                        valign-middle
                        wd-lg-300
                        tx-12
                        text-left
                        pd-t-15 pd-b-15 pd-l-0
                        pos-relative
                      "
                    >
                      <div class="d-flex align-items-center pd-l-25">
                        <a
                          class="p-img-wrap mg-x-5"
                          href="javascript:;"
                          v-lazy:background-image="rawSku.propertyImage"
                          :data-i="i"
                          style="
                            background-size: cover;
                            background-position: center;
                          "
                          @click="preview(rawSku.propertyImage, rawSku.name)"
                        >
                        </a>
                        <div class="p-info">
                          <p class="mg-b-5 d-flex align-items-center"></p>
                          <p class="mg-b-5">
                            <span class="tx-white">{{ rawSku.name }}</span>
                          </p>

                          <p class="mg-b-5">
                            {{ $t("product.重量") }}(g):
                            <span class="tx-white">{{ rawSku.weight }}</span>
                          </p>
                          <p class="mg-b-5">
                            SKU:
                            <span class="tx-white mg-r-5">{{
                              rawSku.sku
                            }}</span>
                            <a
                              v-show="rawSku.sku"
                              class="to-clipboard tx-info mg-l-5"
                              href="javascript:;"
                              :data-clipboard-text="rawSku.sku"
                            >
                              <i class="icon ion-clipboard"></i>
                            </a>
                          </p>
                          <p class="mg-b-5">
                            {{ $t("product.分类") }}:
                            <span class="tx-white">{{
                              rawSku.categoryPath
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span
                          :class="
                            rawSku.status == 2 ? 'tx-danger' : 'tx-success'
                          "
                          >{{ $t(status[rawSku.status]) }}</span
                        >
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="mg-r-5"
                          >{{ $t("product.库存总量") }}:</span
                        >
                        <span class="tx-gray-300">{{
                          rawSku.totalInventory ? rawSku.totalInventory : "---"
                        }}</span>
                      </div>
                      <div>
                        <span class="mg-r-5"
                          >{{ $t("product.未发数量") }}:</span
                        >
                        <span class="tx-gray-300">{{
                          rawSku.totalWait ? rawSku.totalWait : "---"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="mg-r-5">{{ $t("product.数量") }}:</span>
                        <span class="tx-gray-300">{{
                          rawSku.quantity ? rawSku.quantity : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="mg-r-5">{{ $t("product.成本价") }}:</span>
                        <span class="tx-gray-300">{{
                          rawSku.price ? formatNum(rawSku.price, 4) : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
                      <p class="mg-b-5">
                        <a
                          class="tx-underline tx-info tx-12"
                          href="javascript:;"
                          @click="editQuantityRaw(index, i)"
                          >{{ $t("product.修改数量") }}</a
                        >
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr
            v-if="
              item.positions &&
              item.positions.length > 0 &&
              item.rawSkus &&
              item.rawSkus.length > 0
            "
          >
            <td
              colspan="6"
              class="pd-l-30"
              style="padding-top: 0; padding-bottom: 0; border-top: none"
            >
              <div class="pd-l-30">
                <a
                  @click="innerTableStatus(index)"
                  href="javascript:;"
                  class="tx-info tx-underline tx-14"
                >
                  <i
                    class="fa tx-white tx-16"
                    :class="
                      openInner[index] ? 'fa-minus-square' : 'fa-plus-square'
                    "
                  ></i>
                  {{ $t("product.仓库仓位信息") }}
                </a>
              </div>
            </td>
          </tr>
          <tr
            :style="{ display: openInner[index] ? 'table-row' : 'none' }"
            class="collapse"
          >
            <td class="inner-wrap tx-12" colspan="6">
              <table
                class="
                  table
                  mg-b-0
                  table-contact
                  product-table-inner
                  data-table
                "
              >
                <tbody>
                  <tr>
                    <td
                      class="
                        wd-lg-300
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                      style="padding-left: 35px"
                    >
                      {{ $t("product.仓库【仓位】") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.库存量") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.警戒库存") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      $t('product.操作')
                    </td>
                  </tr>
                  <tr
                    v-for="(position, positionindex) in item.positions"
                    :key="positionindex"
                  >
                    <td
                      class="
                        valign-middle
                        wd-lg-300
                        tx-12
                        text-left
                        pd-t-15 pd-b-15
                        pos-relative
                      "
                      style="padding-left: 35px"
                    >
                      <div>
                        <span class="tx-gray-300"
                          >{{ position.warehouseName }}[{{
                            position.name
                          }}]</span
                        >
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="tx-gray-300">{{
                          position.quantity ? position.quantity : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        <span class="tx-gray-300">{{
                          position.warningCnt ? position.warningCnt : "0"
                        }}</span>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
                      <p class="mg-b-5">
                        <a
                          class="tx-underline tx-info tx-12"
                          href="javascript:;"
                          @click="changeWarehouse(item, position)"
                          >{{ $t("product.更换仓位") }}</a
                        >
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-show="(!items || items.length < 1) && !first_loading"
        class="nodata mg-t-50 mg-b-50 text-center tx-24"
      >
        <i class="fa fa-ban"></i>{{ $t("product.没有符合条件的库存商品") }}
      </div>
    </div>
    <div class="card bd-gray-400" v-if="changeType == 2">
      <table
        class="table mg-b-0 table-contact product-table data-table"
        id="productListTable"
      >
        <thead>
          <tr>
            <th class="wd-lg-300">
              <label class="ckbox mg-b-0 d-inline-block valign-middle">
                <input
                  type="checkbox"
                  :checked="isAll"
                  @change="changeAllCheck($event)"
                />
                <span></span>
              </label>
              {{ $t("product.组合商品信息") }}
            </th>
            <th class="wd-lg-200 tx-10-force tx-mont tx-medium hidden-xs-down">
              {{ $t("product.状态") }}
            </th>
            <th class="wd-lg-300 tx-10-force tx-mont tx-medium hidden-xs-down">
              {{ $t("product.组合重量（g）") }}
            </th>
            <th class="wd-lg-300 tx-10-force tx-mont tx-medium hidden-xs-down">
              {{ $t("product.组合成本（￥）") }}
            </th>
            <th class="wd-lg-300 tx-10-force tx-mont tx-medium hidden-xs-down">
              {{ $t("product.创建时间") }}
            </th>
            <th class="wd-lg-150 tx-10-force tx-mont tx-medium hidden-xs-down">
              {{ $t("product.操作") }}
            </th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in items" :key="index">
          <tr>
            <td
              class="
                valign-middle
                wd-lg-300
                tx-12
                text-left
                pd-t-15 pd-b-15
                pos-relative
              "
            >
              <div class="d-flex align-items-center">
                <label class="ckbox mg-b-0 d-inline-block valign-middle">
                  <input type="checkbox" :value="item.sku" v-model="checkArr" />
                  <span></span>
                </label>
                <a
                  class="p-img-wrap mg-x-5"
                  href="javascript:;"
                  v-lazy:background-image="item.propertyImage"
                  :data-i="index"
                  :style="{
                    backgroundSize: scale[index].scale ? 'auto 100%' : '100%',
                  }"
                  @click="preview(item.propertyImage, item.name)"
                >
                </a>
                <div class="p-info">
                  <div class="mg-b-5 d-flex align-items-center">
                    <p class="mg-b-5">
                      <span class="tx-white">{{ item.name }}</span>
                    </p>
                  </div>
                  <p class="mg-b-5">
                    SKU:
                    <span class="tx-white mg-r-5">{{ item.sku }}</span>
                    <a
                      v-show="item.sku"
                      class="to-clipboard tx-info mg-l-5"
                      href="javascript:;"
                      :data-clipboard-text="item.sku"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </p>
                  <p class="mg-b-5">
                    SPU:
                    <span class="tx-white">{{ item.spu }}</span>
                  </p>
                  <p class="mg-b-5">
                    {{ $t("product.客户") }}SKU:
                    <span v-if="item.virtualSku.length" class="tx-white">
                      <template v-for="(vSku, vI) in item.virtualSku">
                        <span v-if="vI < 6" :key="vSku.id">
                          {{ vSku.virtualSku }}
                          <template v-if="vI < item.virtualSku.length - 1">
                            $t('product.，')
                          </template>
                        </span>
                      </template>
                      <span v-if="item.virtualSku.length > 5">
                        {{ $t("product.等") }}
                        <a
                          class="tx-info"
                          href="javascript:;"
                          @click="openVirtualSku(item)"
                          >{{ item.virtualSku.length }}</a
                        >
                        {{ $t("product.个") }}
                      </span>
                    </span>
                    <span v-else>---</span>
                  </p>
                </div>
              </div>
              <div class="pd-l-30 mg-t-5" v-if="item.comboSkus.length > 0">
                <a
                  @click="innerTableStatus(index)"
                  href="javascript:;"
                  class="tx-info tx-underline tx-14"
                >
                  <i
                    class="fa tx-white tx-16"
                    :class="
                      openInner[index] ? 'fa-minus-square' : 'fa-plus-square'
                    "
                  ></i>
                  {{ $t("product.库存商品信息") }}
                </a>
              </div>
            </td>
            <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
              <div>
                <span :class="item.status == 2 ? 'tx-danger' : 'tx-success'">{{
                  $t(status[item.status])
                }}</span>
              </div>
            </td>
            <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
              <div>
                {{ item.totalWeight }}
              </div>
            </td>
            <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
              <div>
                {{ item.price ? formatNum(item.price, 4) : "0" }}
              </div>
            </td>
            <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
              <div>0</div>
              <div>0</div>
            </td>
            <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
              <template v-if="!item.notChange">
                <p class="mg-b-5">
                  <a
                    class="tx-underline tx-info tx-12"
                    href="javascript:;"
                    @click="addNewGroupOrder(index)"
                    >{{ $t("product.编辑") }}</a
                  >
                </p>
                <p class="mg-b-5">
                  <a
                    class="tx-underline tx-info tx-12"
                    href="javascript:;"
                    @click="addNewGroupOrder(index, 'copy')"
                    >{{ $t("product.复制") }}</a
                  >
                </p>
                <p class="mg-b-5">
                  <a
                    class="tx-underline tx-info tx-12"
                    href="javascript:;"
                    @click="openLog(index)"
                    >{{ $t("product.备注") }}</a
                  >
                </p>
                <p class="mg-b-5">
                  <a
                    v-if="item.status != 2"
                    class="tx-underline tx-danger tx-12"
                    href="javascript:;"
                    @click="changeStatus(index, '2')"
                    >{{ $t("product.停用组合商品") }}</a
                  >
                  <a
                    v-if="item.status == 2"
                    class="tx-underline tx-info tx-12"
                    href="javascript:;"
                    @click="changeStatus(index, '1')"
                    >{{ $t("product.开启组合商品") }}</a
                  >
                </p>
                <p class="mg-b-0">
                  <a
                    class="tx-underline tx-danger tx-12"
                    href="javascript:;"
                    @click="removeGroup(index)"
                    >{{ $t("product.删除组合商品") }}</a
                  >
                </p>
              </template>
            </td>
          </tr>
          <tr
            v-if="item.comboSkus.length > 0"
            :style="{ display: openInner[index] ? 'table-row' : 'none' }"
            class="collapse"
          >
            <td class="inner-wrap tx-12" colspan="6">
              <table
                class="
                  table
                  mg-b-0
                  table-contact
                  product-table-inner
                  data-table
                "
              >
                <tbody>
                  <tr>
                    <td
                      class="
                        wd-lg-500
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                      style="padding-left: 35px"
                    >
                      {{ $t("product.商品信息") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.重量（g）") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.成本（￥）") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.组成数量") }}
                    </td>
                    <td
                      class="
                        wd-lg-150
                        tx-10-force tx-mont tx-medium
                        hidden-xs-down
                        tx-gray-500 tx-bold
                      "
                    >
                      {{ $t("product.操作") }}
                    </td>
                  </tr>
                  <tr v-for="(sku, skui) in item.comboSkus" :key="index + skui">
                    <td
                      class="
                        valign-middle
                        wd-lg-300
                        tx-12
                        text-left
                        pd-t-15 pd-b-15
                        pos-relative
                      "
                      style="padding-left: 35px"
                    >
                      <div class="d-flex align-items-center">
                        <a
                          class="p-img-wrap mg-x-5"
                          href="javascript:;"
                          :data-i="index"
                          :data-j="skui"
                          v-lazy:background-image="sku.propertyImage"
                          :style="{
                            backgroundSize: scale[index].sub[skui]
                              ? 'auto 100%'
                              : '100%',
                          }"
                          @click="preview(sku.propertyImage, sku.sku)"
                        >
                        </a>
                        <div class="p-info">
                          <p class="mg-b-5">
                            <span class="tx-white">{{
                              sku.name ? sku.name : "---"
                            }}</span>
                          </p>
                          <p class="mg-b-5">
                            SKU:
                            <span class="tx-white mg-r-5">{{
                              sku.sku ? sku.sku : "---"
                            }}</span>
                            <a
                              v-show="sku.sku"
                              class="to-clipboard tx-info mg-l-5"
                              href="javascript:;"
                              :data-clipboard-text="sku.sku"
                            >
                              <i class="icon ion-clipboard"></i>
                            </a>
                          </p>
                          <p class="mg-b-5">
                            SPU:
                            <span class="tx-white">{{
                              sku.spu ? sku.spu : "---"
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
                      <div>
                        {{ sku.weight ? sku.weight : "---" }}
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-200 tx-12 pd-t-15 pd-b-15">
                      <div>
                        {{ sku.price ? formatNum(sku.price, 4) : "---" }}
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-300 tx-12 pd-t-15 pd-b-15">
                      <div>
                        {{ sku.quantity ? sku.quantity : "0" }}
                      </div>
                    </td>
                    <td class="valign-middle wd-lg-150 tx-12 pd-t-15 pd-b-15">
                      <p class="mg-b-5">
                        <a
                          class="tx-underline tx-info tx-12"
                          href="javascript:;"
                          @click="editQuantity(index, skui)"
                          >{{ $t("product.修改数量") }}</a
                        >
                      </p>
                      <p class="mg-b-0" v-if="sku.skuType != 3">
                        <a
                          class="tx-underline tx-info tx-12"
                          href="javascript:;"
                          @click="setSkuType(index, skui)"
                          >{{ $t("product.设置为电子券类型") }}</a
                        >
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-show="(!items || items.length < 1) && !first_loading"
        class="nodata mg-t-50 mg-b-50 text-center tx-24"
      >
        <i class="fa fa-ban"></i>{{ $t("product.没有符合条件的组合商品") }}
      </div>
    </div>
    <api-loading :show="loading" class="drak"></api-loading>
    <modalEditSupplier :dialog="supplierDialog" @close="close" />
    <modalEditMaterial :dialog="materialDialog" @close="closeMaterial" />
    <order-log
      :dialog="orderLogDialog"
      v-if="orderLogDialog.visible"
    ></order-log>
  </div>
</template>

<script>
import modalEditSupplier from "./model-edit-supplier.vue";
import OrderLog from './order-log.vue'
import modalEditMaterial from "./modal-edit-material.vue";
export default {
  components: {
    modalEditSupplier,
    modalEditMaterial,
    OrderLog,
  },
  props: [
    "first_loading",
    "items",
    "isAccordion",
    "change_type",
    "check_arr",
    "check_arrGong",
  ],
  data() {
    return {
      changeType: 1,
      openInner: [],
      openInner2: [],
      status: arrDict.storageProStataus,
      checkArr: [],
      checkArrGong: [],
      scale: [],
      userinfo: JSON.parse(localStorage.getItem("userInfo")),
      loading: false,
      materialDialog: {
        visible: false,
        data: {},
      },
      supplierDialog: {
        visible: false,
        data: {},
        supplierMoreData: [],
      },
      orderLogDialog: {
        visible: false,
        data:[]
      },
    };
  },
  watch: {
    change_type: function () {
      this.changeType = this.change_type;
      this.checkArr = [];
      this.checkArrGong = [];
      this.openInnerFormat();
    },
    isAccordion: function () {
      //$t('product.展开折叠')
      this.openInnerFormat();
    },
    check_arr: function () {
      this.checkArr = this.check_arr;
    },
    check_arrGong: function () {
      this.checkArrGong = this.check_arrGong;
    },
    checkArr: function () {
      this.$emit("changeChecked", this.checkArr);
    },
    checkArrGong: function () {
      this.$emit("changeCheckedGong", this.checkArrGong);
    },
    items: {
      handler: function () {
        this.imgScale();
      },
      deep: true,
    },
  },
  filters: {
    purorderStatusStyle(val) {
      val = val - 0;
      let style = "";
      switch (val) {
        case 1:
        case 2:
        case 8:
          style = "tx-warning";
          break;
        case 3:
        case 4:
        case 5:
        case 6:
          style = "tx-success";
          break;
        case -1:
          style = "tx-danger";
          break;
      }
      return style;
    },
  },
  computed: {
    isAll() {
      return this.checkArr.length == this.items.length && this.items.length > 0
        ? true
        : false;
    },
    isAllGong() {
      return this.checkArrGong.length == this.items.length &&
        this.items.length > 0
        ? true
        : false;
    },
  },
  updated() {
    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  mounted() {
    this.openInnerFormat();
  },
  methods: {
    checkHistoryLog(item){
      this.orderLogDialog =  {
        visible: true,
        data: item.operateLog
      }
    },
    delCraft(row) {
      this.loading = true;
      $.api_call(
        "api.SupplierProcess.removeBySupplier",
        { id: row.id },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(r.Message, "success");
            this.$parent.getTableList();
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
    //供应商弹窗
    checkMoreSupplier(item) {
      this.loading = true;
      $.api_call(
        "api.SupplierProductStock.findRawSuppliersByRawStock",
        {
          stockId: item.id,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.supplierDialog = {
              visible: true,
              data: item,
              supplierMoreData: r.Data.Results,
            };
          }
        }
      );
    },
    close() {
      this.supplierDialog = {
        visible: false,
        data: {},
        supplierMoreData: [],
      };
      this.$emit("changeTable", "5");
    },
    //材料弹窗
    checkMaterials(item) {
      this.materialDialog = {
        visible: true,
        data: item,
      };
    },
    closeMaterial() {
      this.materialDialog = {
        visible: false,
        data: {},
      };
      this.$emit("changeTable", "5");
    },
    // 打开更多属性
    openSpecifics(items) {
      this.$emit("openSpecifics", items);
    },
    popContact(event, i, id) {
      this.$emit("popContact", event, i, id);
    },
    minPrice(item) {
      let price = 0;
      if (item.virtualSku.length) {
        price = Number(item.virtualSku[0].price);
      } else {
        price = 0;
      }
      item.virtualSku.forEach((e) => {
        if (Number(e.price) < price) {
          price = Number(e.price);
        }
      });
      return this.formatNum(price, 4);
    },
    maxPrice(item) {
      let price = 0;
      if (item.virtualSku.length) {
        price = Number(item.virtualSku[0].price);
      } else {
        price = 0;
      }
      item.virtualSku.forEach((e) => {
        if (Number(e.price) > price) {
          price = Number(e.price);
        }
      });
      return this.formatNum(price, 4);
    },
    mergeProTemp(item) {
      this.$emit("mergeProTemp", item);
    },
    // 管理虚拟SKU
    openVirtualSku(item) {
      this.$emit("openVirtualSku", item);
    },
    getDesc(item) {
      let html = `<p class="mg-b-5">${item.desc}</p>`;
      return html;
    },
    remarkFormat(item) {
      let html = `
      <p class="mg-b-5"> ${this.$t("product.商品备注")}: ${
        item.productRemark
      }</p>
      <p class="mg-b-5"> ${this.$t("product.销售备注")}: ${item.saleRemark}</p>
      <p class="mg-b-5"> ${this.$t("product.采购备注")}: ${
        item.purchaseRemark
      }</p>
      `;
      return html;
    },
    selectNewProduct(sku) {
      localStorage.setItem("selectNewProductSKU", sku);
      window.close();
    },
    preview(img, text) {
      this.$store.commit("setImgItem", [
        {
          img,
          text,
        },
      ]);
      this.$parent.loading = true;
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        if (viewer.images.length) viewer.show();
        this.$parent.loading = false;
      }, 500);
    },
    delProModal(i) {
      this.$emit("delProModal", i);
    },
    imgScale() {
      this.scale = [];
      let vm = this;
      if (this.items.length > 0) {
        for (let i = 0; i < this.items.length; i++) {
          this.scale.push({ scale: false, sub: [] });
          if (this.items[i].propertyImage) {
            let img = new Image();
            img.src = this.items[i].propertyImage;
            img.onload = function () {
              if (img.width > img.height) {
                vm.$set(vm.scale[i], "scale", true);
              }
            };
          }
          if (this.items[i].comboSkus && this.items[i].comboSkus.length > 0) {
            for (let j = 0; j < this.items[i].comboSkus.length; j++) {
              this.scale[i].sub.push(false);
              if (this.items[i].comboSkus[j].propertyImage) {
                let img = new Image();
                img.src = this.items[i].comboSkus[j].propertyImage;
                img.onload = function () {
                  if (img.width > img.height) {
                    vm.$set(vm.scale[i].sub, j, true);
                  }
                };
              }
            }
          }
        }
      }
    },
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArr.push(e.sku);
        });
      }
    },
    changeAllCheckGong(e) {
      this.checkArrGong = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArrGong.push(e.id);
        });
      }
    },
    changeWarehouse(item, position) {
      this.$emit("changeWarehouse", item, position);
    },
    openLog(i) {
      this.$emit("openLog", i);
    },
    editQuantity(i, t) {
      this.$emit("editQuantity", i, t);
    },
    editQuantityRaw(i, t) {
      this.$emit("editQuantityRaw", i, t);
    },
    addNewOrder(i, type) {
      this.$emit("addNewOrder", i, type);
    },
    setSkuType(i, t) {
      this.$emit("setSkuType", i, t);
    },
    uploadSkuType(id) {
      this.$emit("uploadSkuType", id);
    },
    checkSkuType(id) {
      this.$emit("checkSkuType", id);
    },
    removeGroup(i) {
      this.$emit("removeGroup", i);
    },
    changeStatus(i, type) {
      this.$emit("changeStatus", i, type);
    },
    innerTableStatus(i) {
      this.$set(this.openInner, i, !this.openInner[i]);
    },
    innerTableStatus2(i) {
      this.$set(this.openInner2, i, !this.openInner2[i]);
    },
    openInnerFormat() {
      this.openInner = [];
      for (let i = 0; i < this.items.length; i++) {
        this.openInner.push(!this.isAccordion);
        this.openInner2.push(!this.isAccordion);
      }
    },
    changeTable(type) {
      if (this.changeType == type) return;
      this.$emit("changeTable", type);
    },
    addNewGroupOrder(i, type) {
      this.$emit("addNewGroupOrder", i, type);
    },
  },
};
</script>
<style type="text/css">
.product-table .p-img-wrap {
  width: 80px;
  height: 80px;
}
</style>
<style lang="less" scoped>
.white-body {
  .body-bg {
    background: #f6f6f6;
  }
  .tabs {
    li {
      a.active {
        background-color: #f6f6f6;
        border-bottom-color: #f6f6f6;
      }
    }
  }
}
.list-body {
  .img-wrap {
    min-width: 80px;
    min-height: 80px;
    width: 80px;
    height: 80px;
    background-size: cover;
    background-position: center;
    border: 1px #ddd solid;
  }
}
.pro-info {
  max-width: 300px;
  flex: 1;
  word-break: break-all;
}
.ft-bold {
  font-weight: bold;
  -webkit-text-stroke: 2px rgb(153, 144, 144);
}
.cur-pt {
  cursor: pointer;
}
</style>